<div *ngIf="isLoading" class="loading-overlay center-loader">
  <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>

<div class="modern-header" *ngIf="!isDashboard && !isAiInterview">
  <div class="header-left">
    <div class="page-title">
      <ng-container *ngIf="isCopilotMode; else defaultBreadcrumb">
        <div class="copilot-breadcrumb">
          <div class="title-group">
            <span class="copilot-title">{{ copilotTitle }}</span>
          </div>
          <span class="badge alpha">BETA</span>
        </div>
      </ng-container>
      <ng-template #defaultBreadcrumb>
        <xng-breadcrumb class="breadCrumb" [separator]="'>'" [autoGenerate]="true"></xng-breadcrumb>
      </ng-template>
    </div>
  </div>
  
  <div class="header-center">
    <div *ngIf="showSearchBar" class="search-container">
      <em class="pi pi-search search-icon"></em>
      <input 
        (click)="showSpotlightSearch$.next()"
        (focus)="showSpotlightSearch$.next()"
        (keyup.enter)="searchList()"
        [(ngModel)]="searchText" 
        (ngModelChange)="searchTermUpdate()"
        class="search-input"
        type="text"
        readonly
        placeholder="Search here ..."
        [attr.aria-label]="'Search input'"
      >
    </div>
  </div>
  
  <div class="header-right" [class.flex-based]="flexBasedUi">
    <button
      *ngIf="searchItem === 'Events' && userPrivileges.has('event.create')"
      pButton
      type="button"
      class="create-btn"
      (click)="onCreateEventClick()"
      [attr.aria-label]="'Create new event'"
      label="Create Event">
    </button>
    <button
    *ngIf="searchItem === 'Roles' && userPrivileges.has('job_role.create')"
    pButton
    type="button"
    class="create-btn"
    (click)="onCreateRoleClick()"
    [attr.aria-label]="'Create new role'"
    label="Create Role">
  </button>
  <button
      *ngIf="searchItem === 'Candidate' && (userPrivileges.has('candidate.invite') || userPrivileges.has('candidate.bulk_action'))"
      pButton
    type="button"
    class="create-btn"
    (click)="onInviteCandidateClick()"
    [attr.aria-label]="'Invite new candidate'"
    label="Invite Candidate">
  </button>
    
  <div class="notification-icon"
  pTooltip="Coming soon"
  tooltipPosition="right">
<img src="assets/icons-svg/notification.svg" alt="Notification" />
</div>

    
<div (click)="logoutPanel.toggle($event)" class="user-profile" [attr.aria-label]="'User profile menu'" tabindex="0" role="button">
  <div class="user-avatar-wrapper">
    <div class="user-initials" *ngIf="userMeta$ | async as userMeta">
      {{getUserInitials(userMeta.user_profile)}}
    </div>
  </div>    
  <div class="user-info">
    <span class="user-name" *ngIf="userMeta$ | async as userMeta" [title]="getFullName(userMeta.user_profile)">
      {{getFullName(userMeta.user_profile)}}
    </span>
    <em class="pi pi-chevron-down dropdown-icon" [attr.aria-hidden]="true"></em>
  </div>
</div>  
    
<p-popover #logoutPanel styleClass="profile-overlay">
  <div class="profile-dropdown">
    <!-- User Details Section -->
    <div class="user-details-section" *ngIf="userMeta$ | async as userMeta">
      <div class="user-avatar-large">
        <div class="user-initials-large">{{getUserInitials(userMeta.user_profile)}}</div>
      </div>
      <div class="user-details">
        <h4 class="user-full-name">{{getFullName(userMeta.user_profile)}}</h4>
        <p class="user-role">{{userMeta.role_details?.name || '-'}}</p>
        <p class="user-email">{{userMeta.user_profile?.email || '-'}}</p>
      </div>
    </div>
    
    <!-- Menu Options -->
    <div class="menu-options">
      <div class="menu-item" (click)="viewProfile(); logoutPanel.hide()" role="menuitem" tabindex="0">
        <em class="pi pi-user menu-icon"></em>
        <span>View Profile</span>
      </div>

      <hr />
      
      <div class="menu-item logout-item" (click)="signOut(); logoutPanel.hide()" role="menuitem" tabindex="0">
        <em class="pi pi-sign-out menu-icon"></em>
        <span>Logout</span>
      </div>
    </div>
  </div>
</p-popover>
  </div>
</div>

<p-drawer
  class="event-sidebar"
  appendTo="body"
  [baseZIndex]="1100"
  [(visible)]="addEventSlider"
  [showCloseIcon]="true"
  position="right"
  [style]="{ width: '60vw' }"
  [ariaCloseLabel]="'Close event form'">
  <app-events-add 
    *ngIf="addEventSlider" 
    (closeEventSlider)="onCloseEventSlider($event)">
  </app-events-add>
</p-drawer>

<p-dialog [(visible)]="addRoleDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="neo-dialog" [style]="{width: '60vw', maxWidth: '90vw'}" [baseZIndex]="1100">
  <app-role-add *ngIf="addRoleDialog" #roleAddComponent (closeAddRole)="onCloseRoleDialog($event)">
  </app-role-add>
</p-dialog>

<app-invite-candidate 
  *ngIf="addCandidateSlider && false"
  (closeAddCandidate)="onCloseCandidateSlider($event)">
</app-invite-candidate>

<app-invite-candidate-v2 
  *ngIf="addCandidateSlider"
  from="header"
  (close$)="onCloseCandidateSlider($event)">
</app-invite-candidate-v2>

<app-spotlight-search [showSpotlightSearch$]="showSpotlightSearch$"></app-spotlight-search>